<template>
    <router-link :to="{name: 'home'}">
        <!-- <img src="./logo.svg" alt="logo">
        <img class="title" src="./Kg.svg"> -->
        <img src="./gakg.svg" alt="gakg">
    </router-link>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#fff'
        }
    }
}
</script>
<style lang="less" scoped>
    a {
        text-decoration: none;
    }
    .title {
        margin-left: 16px;
        vertical-align: bottom;
    }
</style>


// WEBPACK FOOTER //
// src/components/Logo/index.vue